import RankingStat from "../../entities/RankingStat.js";

class DerivativeRankingStatCalculatorBase {
    canCalculate(parameter) {
        if (!this.isParameterValid(parameter)) {
            throw new TypeError('parameter must be an object containing key and aggregator properties');
        }

        return this.canCalculateStat(parameter);
    }

    isParameterValid(parameter) {
        return typeof(parameter) === 'object'
            && parameter.hasOwnProperty('key')
            && parameter.hasOwnProperty('aggregator')
        ;
    }

    calculate(parameter, rankingStats, includeDefault) {
        const requiredDependencies = this.getDependencies(parameter);
        const availableDependencies = [];
        for (let d = 0; d < requiredDependencies.length; d++) {
            const dependency = requiredDependencies[d];
            const foundDependency = rankingStats.find(p => p.parameter === dependency.key);
            if (!foundDependency) {
                if (includeDefault) {
                    return RankingStat.getDefault(parameter, 0);
                }

                throw new Error(`unable to find required dependency - ${dependency.key} - which is necessary to calculate ${parameter.key}`);
            }

            availableDependencies[d] = foundDependency;
        }

        return this.calculateStat(parameter, availableDependencies);
    }

    getDependencies(parameter) {
        if (!this.isParameterValid(parameter)) {
            throw new TypeError('parameter is not supported');
        }

        return this.listDependencies(parameter);
    }

    // private abstract methods goes here
    /**
     * 
     * @param {string} parameter - name of the parameter
     * @returns {any[]} list of dependencies
     */
    listDependencies(parameter) {
        throw new Error('listDependencies not implemented');
    }

    /**
     * Checks whether given parameter can be handled by this class
     * @param {string} parameter - name of the parameter
     * @returns {boolean} 
     */
    canCalculateStat(parameter) {
        throw new Error('canCalculateStat not implemented');
    }

    /**
     * Calculates statistical value
     * @param {string} parameter - name of the parameter
     * @param {RankingStat[]} dependencies - list of dependencies needed for calculation
     * @returns {RankingStat?} - ranking stat instance or null
     */
    calculateStat(parameter, dependencies) {
        throw new Error('calculateStat not implemented');
    }
}

export default DerivativeRankingStatCalculatorBase;